import React, { useReducer, useContext } from 'react';
import firebase from 'firebase';

import { firestoreInitialize } from 'config/firebase/client';

import PromotionsContext from './PromotionsContext';
import PromotionsReducer from './PromotionsReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const PromotionsState = (props) => {
    const initialState = {
        getPromotions: {
            promotions: [],
            firstPromotion: null,
            lastPromotion: null,
            nextPromotions: null,
            promotionsFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getPromotionsAllMonth: {
            promotions: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        createPromotions: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updatePromotionsById: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getPromotionsById: {
            promotion: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        verifyPromotion: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getPromotionsExcel: {
            promotions: [],
            promotionsFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
    }

    const { authenticatedState } = useContext(AuthenticationContext)

    const [state, dispatch] = useReducer(PromotionsReducer, initialState);

    const getPromotions = (nextPage, prevPage) => {
        dispatch({ type: 'GET_PROMOTIONS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalPromotions(nextPage, prevPage);
        } else {
            getPromotionsPerCountry(nextPage, prevPage, authenticatedState.user.pais);
        }
    };

    const getGlobalPromotions = (nextPage, prevPage) => {
        let db = firestoreInitialize();

        if (nextPage) {
            let first = db.collection("Promociones")
                .orderBy('promoId')
                .orderBy('createdOn', 'desc')
                .startAfter(nextPage)
                .limit(10)
                
                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PROMOTIONS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Promociones")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))   
        } else if (prevPage) {
            let first = db.collection("Promociones")
                .orderBy('promoId')
                .orderBy('createdOn', 'desc')
                .endBefore(prevPage)
                .limitToLast(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PROMOTIONS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Promociones")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))   
        } else {
            let first = db.collection("Promociones")
                .orderBy('createdOn', 'desc')
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PROMOTIONS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Promociones")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))   
        }
    };

    const getPromotionsPerCountry = (nextPage, prevPage, country) => {
        let db = firestoreInitialize();

        if (nextPage) {
            db.collection("Promociones")
                .where('promoId', '==', nextPage)
                .limit(1)
                .get().then((querySnapshot) => {

                    let first = db.collection("Promociones")
                    .where('pais', '==', country)
                    .orderBy('createdOn', 'desc')
                    .startAfter(querySnapshot.docs[0])
                    .limit(10)
                    
                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_PROMOTIONS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Promociones")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                    .catch(error => dispatch({ type: 'GET_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))   
                })
        } else if (prevPage) {
            db.collection("Promociones")
                .where('promoId', '==', prevPage)
                .limit(1)
                .get().then((querySnapshot) => {

                    let first = db.collection("Promociones")
                        .where('pais', '==', country)
                        .orderBy('createdOn', 'desc')
                        .endBefore(querySnapshot.docs[0])
                    
                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_PROMOTIONS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=data.length-10];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Promociones")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                const length = data.length - 10;

                                data.splice(0, length);

                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))   
        } else {
            let first = db.collection("Promociones")
                .where('pais', '==', country)
                .orderBy('createdOn', 'desc')
                .limit(10)
                
                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PROMOTIONS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Promociones")
                            .where('pais', '==', country)
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PROMOTIONS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))   
        }
    };

    const getPromotionsExcel = () => {
        dispatch({ type: 'GET_PROMOTIONS_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalPromotionsExcel();
        } else {
            getPromotionsPerCountryExcel(authenticatedState.user.pais);
        }
    }

    const getGlobalPromotionsExcel = () => {
        let db = firestoreInitialize();

        let first = db.collection("Promociones")
            .orderBy('createdOn', 'desc')

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_PROMOTIONS_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
            })
            .catch(error => dispatch({ type: 'GET_PROMOTIONS_EXCEL_ERROR', payload: { code: 'promotions/error', message: error } }))   
    };

    const getPromotionsPerCountryExcel = (country) => {
        let db = firestoreInitialize();

        let first = db.collection("Promociones")
            .where('pais', "==", country)
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            dispatch({ type: 'GET_PROMOTIONS_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
        })
        .catch(error => dispatch({ type: 'GET_PROMOTIONS_EXCEL_ERROR', payload: { code: 'promotions/error', message: error } }))   
    }

    const createPromotions = (data) => {
        dispatch({ type: 'CREATE_PROMOTIONS_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'CREATE_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } })
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collection("Promociones").add({
                        promoId: "",
                        titulo: data.name,
                        status: data.status,
                        descripcion: data.description,
                        condiciones: data.conditions,
                        cupos: parseInt(data.quota),
                        precio: parseInt(data.price),
                        peso: parseInt(data.weight),
                        domicilio: parseInt(data.domicilie),
                        delivery: parseInt(data.delivery),
                        tipoPromocion: data.type,
                        cantidad: parseInt(data.amount),
                        urlImagen: downloadURL,
                        createdOn: firebase.firestore.FieldValue.serverTimestamp()
                    }).then((doc) => {
                        db.collection("Promociones").doc(doc.id).update({
                            promoId: doc.id
                        }).then(() => {
                            dispatch({ type: 'CREATE_PROMOTIONS', payload: { data: data } })
                        })
                    })
                    .catch((error) => dispatch({ type: 'CREATE_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))
                });
            });
        } else {
            db.collection("Promociones").add({
                promoId: "",
                titulo: data.name,
                status: data.status,
                descripcion: data.description,
                condiciones: data.conditions,
                cupos: parseInt(data.quota),
                precio: parseInt(data.price),
                peso: parseInt(data.weight),
                domicilio: parseInt(data.domicilie),
                delivery: parseInt(data.delivery),
                tipoPromocion: data.type,
                cantidad: parseInt(data.amount),
                urlImagen: "",
                createdOn: firebase.firestore.FieldValue.serverTimestamp()
            }).then((doc) => {
                db.collection("Promociones").doc(doc.id).update({
                    promoId: doc.id
                }).then(() => {
                    dispatch({ type: 'CREATE_PROMOTIONS', payload: { data: data } })
                })
            })
            .catch((error) => dispatch({ type: 'CREATE_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))
        }
    };

    const updatePromotionsSettingsById = (promoId, data) => {
        dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID_ERROR', payload: { code: 'promotion/update-error', message: error } });
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collection("Promociones").doc(promoId).update({
                        titulo: data.name,
                        status: data.status,
                        descripcion: data.description,
                        condiciones: data.conditions,
                        cupos: parseInt(data.quota),
                        precio: parseInt(data.price),
                        peso: parseInt(data.weight),
                        domicilio: parseInt(data.domicilie),
                        delivery: parseInt(data.delivery),
                        tipoPromocion: data.type,
                        cantidad: parseInt(data.amount),
                        palabrasClave: data.keyPhrases,
                        urlImagen: downloadURL
                    }).then(() => {
                        dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID', payload: { data: data } })
                    })
                    .catch((error) => dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID_ERROR', payload: { code: 'promotions/error', message: error } }))
                });
            });
        } else {
            if (data.deleteImage && data.imagePath.length > 0) {
                let storageRef = storage.refFromURL(data.imagePath);

                storageRef.delete().then(function() {
                    db.collection("Promociones").doc(promoId).update({
                        titulo: data.name,
                        status: data.status,
                        descripcion: data.description,
                        condiciones: data.conditions,
                        cupos: parseInt(data.quota),
                        precio: parseInt(data.price),
                        peso: parseInt(data.weight),
                        domicilio: parseInt(data.domicilie),
                        delivery: parseInt(data.delivery),
                        tipoPromocion: data.type,
                        cantidad: parseInt(data.amount),
                        urlImagen: "",
                        palabrasClave: data.keyPhrases,
                    }).then(() => {
                        dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID', payload: { data: data } })
                    })
                    .catch((error) => dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID_ERROR', payload: { code: 'promotions/error', message: error } }))
                }).catch(function(error) {
                    dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID_ERROR', payload: { code: 'promotion/update-error', message: error } });
                });
            } else {
                db.collection("Promociones").doc(promoId).update({
                    titulo: data.name,
                    status: data.status,
                    descripcion: data.description,
                    condiciones: data.conditions,
                    cupos: parseInt(data.quota),
                    precio: parseInt(data.price),
                    peso: parseInt(data.weight),
                    domicilio: parseInt(data.domicilie),
                    delivery: parseInt(data.delivery),
                    tipoPromocion: data.type,
                    cantidad: parseInt(data.amount),
                    palabrasClave: data.keyPhrases,
                }).then((doc) => {
                    dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID', payload: { data: data } })
                })
                .catch((error) => dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID_ERROR', payload: { code: 'promotions/error', message: error } }))
            }
        }
    }

    const getPromotionsNotApproved = (page) => {
        dispatch({ type: 'GET_PROMOTIONS_LOADING' });

        getPromotionsNotApprovedPerCountry(authenticatedState.user.pais, page);
    };

    const getPromotionsNotApprovedPerCountry = (country, page) => {
        let db = firestoreInitialize();

        db.collection('Promociones')
            .where('pais', '==', country)
            .get()
            .then((querySnapshot) => {
                let promotions = querySnapshot.docs.map(doc => doc.data())
                let nextPage;

                promotions = promotions.filter(promotion => typeof promotion.isApproved === 'undefined');

                let nextPromotions;

                if (page) {
                    if (page === '1') {
                        nextPromotions = promotions.slice(10, 11);
    
                        if (nextPromotions.length === 1) {
                            nextPromotions = true;
                        } else {
                            nextPromotions = false;
                        }
    
                        promotions = promotions.slice(0, 10);
                    } else {
                        nextPage = `${page}0`;
    
                        nextPromotions = promotions.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);
    
                        if (nextPromotions.length === 1) {
                            nextPromotions = true;
                        } else {
                            nextPromotions = false;
                        }
    
                        promotions = promotions.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                    }
                } else {
                    nextPromotions = false;
                }

                dispatch({ type: 'GET_PROMOTIONS', payload: { data: promotions, first: querySnapshot.docs[querySnapshot.docs.length=0], last: querySnapshot.docs[querySnapshot.docs.length-1], next: nextPromotions} });
            })
            .catch((error) => dispatch({ type: 'GET_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))
    }

    const getPromotionsById = (id) => {
        dispatch({ type: 'GET_PROMOTIONS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Promociones").doc(id);

        docRef.get().then((doc) => {
            if (doc.exists) {
                dispatch({ type: 'GET_PROMOTIONS_BY_ID', payload: doc.data() })
            } else {
                dispatch({ type: 'GET_PROMOTIONS_BY_ID', payload: null })
            }
        }).catch((error) => {
            dispatch({ type: 'GET_PROMOTIONS_BY_ID_ERROR', payload: { code: 'promotions/error', message: error } })
        });
    };

    const updatePromotionsById = (id, data) => {
        dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Promociones").doc(id);

        let date = firebase.firestore.FieldValue.serverTimestamp();

        docRef.update({
            isApproved: data.isApproved,
            status: data.status,
            usuarioAtendio: data.userAttends,
            fechaCierre: date,
            comentario: data.commentary
        })
        .then(() => {
            dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID', payload: { 
                newIsApproved: data.isApproved,
                newStatus: data.status,
                newUserAttends: data.userAttends,
                newCommentary: data.commentary
            }});
        })
        .catch((error) => {
            dispatch({ type: 'UPDATE_PROMOTIONS_BY_ID_ERROR', payload: { code: 'promotion/update-error', message: error } });
        });
    };

    const updateVerifyPromotion = (id) => {
        dispatch({ type: 'VERIFY_PROMOTION_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Promociones").doc(id);

        docRef.update({
            status: false,
        })
        .then(() => {
            dispatch({ type: 'VERIFY_PROMOTION_BY_ID' });
        })
        .catch((error) => {
            dispatch({ type: 'VERIFY_PROMOTION_BY_ID_ERROR', payload: { code: 'promotion/update-error', message: error } });
        });
    };

    const getPromotionsByAlly = (ally) => {
        dispatch({ type: "GET_PROMOTIONS_LOADING" })

        let db = firestoreInitialize();

        db.collection('Promociones')
            .where("aliadoId", "==", ally)
            .get()
            .then((querySnapshot) => dispatch({ type: 'GET_PROMOTIONS', payload: { data: querySnapshot.docs.map(doc => doc.data()), first: null, last: null } }))
            .catch((error) => dispatch({ type: 'GET_PROMOTIONS_ERROR', payload: { code: "promotion/error", message: error } }))
    };

    const getPromotionsByName = (query) => {
        dispatch({ type: 'GET_PROMOTIONS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalPromotionsByName(query);
        } else {
            getPromotionsByNameCountry(query, authenticatedState.user.pais);
        }
    };

    const getGlobalPromotionsByName = (query) => {
        let db = firestoreInitialize();

        db.collection('Promociones')
        .get()
        .then((documentSnapshots) => {
            const data = documentSnapshots.docs.map(doc => doc.data());
            let results = [];

            for (let i = 0; i < data.length; i++) {
                if ((data[i].titulo && data[i].titulo.toLowerCase().includes(query.toLowerCase())) || (data[i].descripcion && data[i].descripcion.toLowerCase().includes(query.toLowerCase()))) {
                    results.push(data[i]);
                }
            }

            dispatch({ type: 'GET_PROMOTIONS', payload: { data: results, first: null, last: null, next: false }});
        })
        .catch((error) => dispatch({ type: 'GET_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))
    }

    const getPromotionsByNameCountry = (query, country) => {
        let db = firestoreInitialize();

        db.collection('Promociones')
        .where('pais', '==', country)
        .get()
        .then((documentSnapshots) => {
            const data = documentSnapshots.docs.map(doc => doc.data());
            let results = [];

            for (let i = 0; i < data.length; i++) {
                if ((data[i].titulo && data[i].titulo.toLowerCase().includes(query.toLowerCase())) || (data[i].descripcion && data[i].descripcion.toLowerCase().includes(query.toLowerCase()))) {
                    results.push(data[i]);
                }
            }

            dispatch({ type: 'GET_PROMOTIONS', payload: { data: results, first: null, last: null, next: false }});
        })
        .catch((error) => dispatch({ type: 'GET_PROMOTIONS_ERROR', payload: { code: 'promotions/error', message: error } }))
    }

    const getPromotionsFilter = (status, country, page) => {
        dispatch({ type: 'GET_PROMOTIONS_FILTER_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalPromotionsFilter(status, country, page);
        } else {
            getPromotionsFilterPerCountry(status, page, authenticatedState.user.pais);
        }
    }

    const getGlobalPromotionsFilter = (status, country, page) => {
        let db = firestoreInitialize();

        let first = db.collection("Promociones")
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            let promotions = documentSnapshots.docs.map(doc => doc.data())

            let nextPage;
    
            if (status) {
                if (status === 'Registrada') {
                    promotions = promotions.filter(promotion => promotion.isApproved === true);
                } else if (status === 'Negado') {
                    promotions = promotions.filter(promotion => promotion.isApproved === false);
                } else {
                    promotions = promotions.filter(promotion => typeof promotion.isApproved === 'undefined');
                }
            }

            if (country) {
                promotions = promotions.filter(promotion => promotion.pais === country)
            }

            let nextPromotions;

            if (page === '1') {
                nextPromotions = promotions.slice(10, 11);

                if (nextPromotions.length === 1) {
                    nextPromotions = true;
                } else {
                    nextPromotions = false;
                }

                promotions = promotions.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextPromotions = promotions.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextPromotions.length === 1) {
                    nextPromotions = true;
                } else {
                    nextPromotions = false;
                }

                promotions = promotions.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_PROMOTIONS_FILTER', payload: { data: promotions, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextPromotions } })
        })
        .catch(error => dispatch({ type: 'GET_PROMOTIONS_FILTER_ERROR', payload: { code: 'promotions/error', message: error } }))     
    }

    const getPromotionsFilterPerCountry = (status, page, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Promociones")
            .where("pais", "==", country)
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            let newData = [];
            let nextPage;
    
            if (status) {
                if (status === 'Registrada') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === true);
                } else if (status === 'Negado') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === false);
                } else {
                    newData = dataFetch.filter(dataFetch => typeof dataFetch.isApproved === 'undefined');
                }
            }

            let nextPromotions;

            if (page === '1') {
                nextPromotions = newData.slice(10, 11);

                if (nextPromotions.length === 1) {
                    nextPromotions = true;
                } else {
                    nextPromotions = false;
                }

                newData = newData.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextPromotions = newData.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextPromotions.length === 1) {
                    nextPromotions = true;
                } else {
                    nextPromotions = false;
                }

                newData = newData.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_PROMOTIONS_FILTER', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextPromotions } })
        })
        .catch(error => dispatch({ type: 'GET_PROMOTIONS_FILTER_ERROR', payload: { code: 'promotions/error', message: error } }))     
    }

    const getPromotionsFilterExcel = (status, country) => {
        dispatch({ type: 'GET_PROMOTIONS_FILTER_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalPromotionsFilterExcel(status, country);
        } else {
            getPromotionsFilterPerCountryExcel(status, authenticatedState.user.pais);
        }
    }

    const getGlobalPromotionsFilterExcel = (status, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Promociones")
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            let promotions = documentSnapshots.docs.map(doc => doc.data())

            if (status === 'Registrada') {
                promotions = promotions.filter(promotion => promotion.isApproved === true);
            } else if (status === 'Negado') {
                promotions = promotions.filter(promotion => promotion.isApproved === false);
            } else {
                promotions = promotions.filter(promotion => typeof promotion.isApproved === 'undefined');
            }

            if (country) {
                promotions = promotions.filter(content => content.pais === country)
            }

            dispatch({ type: 'GET_PROMOTIONS_FILTER_EXCEL', payload: { data: promotions, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
        })
        .catch(error => dispatch({ type: 'GET_PROMOTIONS_FILTER_EXCEL_ERROR', payload: { code: 'promotions/error', message: error } }))     
    };

    const getPromotionsFilterPerCountryExcel = (status, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Promociones")
            .where("pais", "==", country)
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            let newData = [];

            if (status) {
                if (status === 'Registrada') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === true);
                } else if (status === 'Negado') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === false);
                } else {
                    newData = dataFetch.filter(dataFetch => typeof dataFetch.isApproved === 'undefined');
                }
            }

            dispatch({ type: 'GET_PROMOTIONS_FILTER_EXCEL', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
        })
        .catch(error => dispatch({ type: 'GET_PROMOTIONS_FILTER_EXCEL_ERROR', payload: { code: 'promotions/error', message: error } }))     
    }

    const getPromotionsAllMonth = async (country) => {
        dispatch({ type: 'GET_PROMOTIONS_ALL_MONTH_LOADING' });

        if (country) {
            getPromotionsAllMonthPerCountry(country);
        } else if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalPromotionsAllMonth();
        } else {
            getPromotionsAllMonthPerCountry(authenticatedState.user.pais);
        }
    };

    const getGlobalPromotionsAllMonth = async () => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let promotionsPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Promociones')
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                promotionsPerMonth.push(documentSnapshots.docs.map(doc => doc.data()))
            })
        }

        dispatch({ type: 'GET_PROMOTIONS_ALL_MONTH', payload: { data: promotionsPerMonth } });
    }

    const getPromotionsAllMonthPerCountry = async (country) => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let promotionsPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Promociones')
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                let data = documentSnapshots.docs.map(doc => doc.data());
                data = data.filter(data => data.pais === country);
                
                promotionsPerMonth.push(data);
            })
        }

        dispatch({ type: 'GET_PROMOTIONS_ALL_MONTH', payload: { data: promotionsPerMonth } });
    }

    const updateApprovedPromotion = (id, isApproved) => {
        dispatch({ type: 'VERIFY_PROMOTION_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Promociones").doc(id);

        docRef.update({
            isApproved: isApproved,
        })
        .then(() => {
            dispatch({ type: 'VERIFY_PROMOTION_BY_ID' });
        })
        .catch((error) => {
            dispatch({ type: 'VERIFY_PROMOTION_BY_ID_ERROR', payload: { code: 'verify-promotion/update-error', message: error } });
        });
    };

    const resetVerifyPromotion = () => {
        dispatch({ type: 'VERIFY_PROMOTION_BY_ID_RESET_STATE' });
    };

    const resetPromotionsState = () => {
        dispatch({ type: 'PROMOTIONS_RESET_STATE' });
    };

    const updatePromotionsResetState = () => {
        dispatch({ type: 'UPDATE_PROMOTIONS_RESET_STATE' });
    };

    const resetPromotionsExcelState = () => {
        dispatch({ type: 'PROMOTIONS_EXCEL_RESET_STATE' });
    };

    return (
        <PromotionsContext.Provider value={{
            promotionsState: state.getPromotions,
            promotionsAllMonthState: state.getPromotionsAllMonth,
            createPromotionsState: state.createPromotions,
            updatePromotionsByIdState: state.updatePromotionsById,
            promotionsByIdState: state.getPromotionsById,
            promotionsUpdateState: state.updatePromotionsById,
            verifyPromotionState: state.verifyPromotion,
            promotionsExcelState: state.getPromotionsExcel,
            getPromotions,
            getPromotionsExcel,
            getPromotionsFilterExcel,
            getPromotionsAllMonth,
            createPromotions,
            updatePromotionsSettingsById,
            getPromotionsNotApproved,
            getPromotionsById,
            updatePromotionsById,
            updateVerifyPromotion,
            getPromotionsByAlly,
            getPromotionsByName,
            getPromotionsFilter,
            updateApprovedPromotion,
            resetPromotionsState,
            resetPromotionsExcelState,
            updatePromotionsResetState,
            resetVerifyPromotion,
        }}>
            {props.children}
        </PromotionsContext.Provider>
    )
}

export default PromotionsState;
